import { createAction, createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const channelsRequest = createRequest(constants.channels);
export const channelsSuccess = createSuccess(constants.channels);
export const channelsFailure = createFailure(constants.channels);

export const channelInfoRequest = createRequest(constants.channelInfo);
export const channelInfoSuccess = createSuccess(constants.channelInfo);
export const channelInfoFailure = createFailure(constants.channelInfo);

// Switches the channel list from unread-only (enough for the header) to every channel.
export const showAllChannels = createAction(constants.showAllChannels);
// Re-fetches the channel list in its current scope, e.g. after the chat socket reconnects.
export const refreshChannels = createAction(constants.refreshChannels);
export const channelAdded = createAction(constants.channelAdded);

export const messagesRequest = createRequest(constants.messages);
export const messagesSuccess = createSuccess(constants.messages);
export const messagesFailure = createFailure(constants.messages);

export const sendMessageRequest = createRequest(constants.sendMessage);
export const sendMessageSuccess = createSuccess(constants.sendMessage);
export const sendMessageFailure = createFailure(constants.sendMessage);

export const markAsReadRequest = createRequest(constants.markAsRead);
export const markAsReadSuccess = createSuccess(constants.markAsRead);
export const markAsReadFailure = createFailure(constants.markAsRead);

export const editMessageRequest = createRequest(constants.editMessage);
export const editMessageSuccess = createSuccess(constants.editMessage);
export const editMessageFailure = createFailure(constants.editMessage);

export const deleteMessageRequest = createRequest(constants.deleteMessage);
export const deleteMessageSuccess = createSuccess(constants.deleteMessage);
export const deleteMessageFailure = createFailure(constants.deleteMessage);

export const searchMessagesRequest = createRequest(constants.searchMessages);
export const searchMessagesSuccess = createSuccess(constants.searchMessages);
export const searchMessagesFailure = createFailure(constants.searchMessages);
export const clearSearch = createAction(constants.clearSearch);

export const newMessageReceived = createAction(constants.newMessageReceived);
export const messageReadReceived = createAction(constants.messageReadReceived);
export const messageEditedReceived = createAction(constants.messageEditedReceived);
export const messageDeletedReceived = createAction(constants.messageDeletedReceived);

export const requestChannels = channelsRequest;
export const requestChannelInfo = channelInfoRequest;
export const requestMessages = messagesRequest;
export const sendMessage = sendMessageRequest;
export const markAsRead = markAsReadRequest;
export const editMessage = editMessageRequest;
export const deleteMessage = deleteMessageRequest;
export const searchMessages = searchMessagesRequest;
